import MDBox from 'src/components/md/MDBox';
import DashboardLayout from 'src/layouts/dashboard/DashboardLayout';
import CircularProgress from '@mui/material/CircularProgress';
import ApiError from 'src/api/ApiError';
import ErrorMessage from 'src/components/errorMessage/ErrorMessage';

type PageProps = React.PropsWithChildren<{
  title?: string;
  subtitle?: string;
  isLoading?: boolean;
  error?: Error | ApiError;
  actions?: React.ReactNode;
}>;

const Page: React.FC<PageProps> = ({
  title,
  subtitle,
  isLoading,
  error,
  actions,
  children,
}) => {
  return (
    <DashboardLayout>
      <MDBox p={3}>
        <div className="flex items-center justify-between">
          {title && (
            <div>
              <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
              {subtitle ? (
                <p className="text-muted-foreground">{subtitle}</p>
              ) : undefined}
            </div>
          )}
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>

        {isLoading ? (
          <MDBox pt={6} pb={3} display="flex" justifyContent="center">
            <CircularProgress />
          </MDBox>
        ) : error ? (
          <MDBox display="flex" justifyContent="center" p={3}>
            <ErrorMessage error={error} />
          </MDBox>
        ) : (
          children
        )}
      </MDBox>
    </DashboardLayout>
  );
};

export default Page;
